import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Navigation } from 'swiper/modules';
import { Swiper as SwiperType } from 'swiper'; // ← import Swiper type
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import './slider.style.css';

type ImgSliderBoxProps = {
  imageList: { id: number; title: string; img: string }[];
  setSelectedImage: any;
  className?: string;
};

const ImgSliderBox = ({ imageList, setSelectedImage, className }: ImgSliderBoxProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleImageClick = (imageUrl: any) => {
    setSelectedImage(imageUrl);
  };

  return (
    <div className={`${className} relative p-2 bg-white/[4%] rounded-2xl `}>
      <Swiper
        slidesPerView={2}
        spaceBetween={20}
        onSlideChange={(swiper: SwiperType) => setCurrentIndex(swiper.activeIndex)} // ← type added
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        initialSlide={1}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
          slideShadows: false,
        }}
        
        modules={[EffectCoverflow, Navigation]}
        className="!w-full !h-[100px]"
      >
        {imageList.map((imageUrl, index) => (
          <SwiperSlide key={index} className="!bg-transparent">
            <div onClick={() => handleImageClick(imageUrl)} className="w-24 h-16 rounded-xl bg-white overflow-hidden shadow-md flex items-center justify-center">
              <img src={imageUrl?.img} alt={`تصویر ${index + 1}`} className="object-cover w-full h-full"/>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImgSliderBox;
